import React, { memo } from 'react';

import config from '../../../config';
import { CAREGIVER_ROLE } from '../../../constants';

import TierBadge from '../../../components/badges/TierBadge';
import BaseBadge from '../../../components/badges/BaseBadge';
import IconWithTooltip from '../../../components/icons/IconWithTooltip';
import { CalendarIcon, DownloadIcon, PhoneIcon } from '../../../components/icons';

const ShiftSlotDisplay = (props) => {
	const {
		slot: {
			caregiver_name: caregiverName,
			is_oriented_worker: isOrientedWorker,
			is_returning_worker: isReturningWorker,
			replaced_caregiver_name: replacedCaregiverName,
			caregiver_phone_number: caregiverPhoneNumber,
			block_schedule_id: blockScheduleId,
			attachment_id: attachmentId,
			slot_claim_role: slotClaimRole,
			slot_id: slotId,
			agency_name: agencyName,
			agency_display_name: agencyDisplayName,
			caregiver = {}
		} = {}
	} = props;

	const hasAttachment = !!attachmentId;
	const { isCaregiverInvited = false, highest_resource_type: resouceType } = caregiver;
	const isExternalWorker = slotClaimRole?.code === CAREGIVER_ROLE.EXTERNAL;
	const displayName = agencyDisplayName || agencyName;

	const showCaregiverCredentials = () =>
		window.open(`${config.HOST_NAME}${config.API_URL}/slot/${slotId}/credential-packet`, '_blank');

	const WorkerTypeBadges = () => {
		const badges = [];
		if (isExternalWorker) badges.push('External worker');
		if (isOrientedWorker) badges.push('Oriented worker');
		if (isReturningWorker && !isOrientedWorker) badges.push('Returning worker');
		if (blockScheduleId) badges.push('Block scheduled');

		return (
			<div className="d-flex justify-content-sm-center align-items-md-center flex-column-sm flex-wrap with-gap-4 mt-2">
				{badges.map((badge) => (
					<BaseBadge
						key={`worker-badge-${badge}`}
						badgeCopy={badge}
						className="worker-type-badge"
						tooltipHtml={badge === 'External Worker' && displayName}
					/>
				))}
			</div>
		);
	};

	return (
		<div className="replaced-caregiver-container">
			{replacedCaregiverName && <div className="replaced-caregiver">{replacedCaregiverName}</div>}
			<div className="replaced-caregiver-flex">
				<div className="current-caregiver">
					<div className="d-flex justify-content-sm-center pt-1">
						{replacedCaregiverName && (
							<img className="mr-2" src="/static/media/replace-arrow.95b782e4.svg" alt="replaced-caregiver-arrow" />
						)}
						{caregiverName ? (
							<>
								{isCaregiverInvited && <IconWithTooltip tooltipText="Invited Professional" icon={<CalendarIcon />} />}
								<span className="caregiver-name">{`${caregiverName}${resouceType ? `, ${resouceType}` : ''}`}</span>
								<TierBadge caregiver={caregiver} caregiverName={caregiverName} />
								{caregiverPhoneNumber && (
									<IconWithTooltip
										tooltipText={caregiverPhoneNumber}
										icon={<PhoneIcon alt="Phone" color="#7200a0" />}
									/>
								)}
								{hasAttachment && (
									<IconWithTooltip
										tooltipText="Click to open credentials"
										icon={<DownloadIcon />}
										onClick={showCaregiverCredentials}
									/>
								)}
							</>
						) : (
							<div className="looking-caregiver-badge">Looking for Professional</div>
						)}
					</div>
					<WorkerTypeBadges />
				</div>
			</div>
		</div>
	);
};

export default memo(ShiftSlotDisplay);
